import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { AttributeDataType, useCsAttribute, useSingleOptionBoolValue, } from "@plansoft-configuration-renderer/framework";
import { useAppTranslator } from "@plansoft-configuration-renderer/localization";
export function SingleOptionBoolNotice() {
    const attribute = useCsAttribute();
    const { singleValue } = useSingleOptionBoolValue();
    const t = useAppTranslator();
    const notices = [];
    if (attribute.dataType !== AttributeDataType.Bool) {
        notices.push(t("ConfigurationRenderer:Warnings.SingleOptionBool.onlyAvailableForBoolean", "Only compatible with boolean attributes."));
    }
    if (attribute.isEditable) {
        notices.push(t("ConfigurationRenderer:Warnings.SingleOptionBool.isEditableNotSupported", "Editable attributes are not supported."));
    }
    if (attribute.isMultiValued) {
        notices.push(t("ConfigurationRenderer:Warnings.SingleOptionBool.isMultiValuedNotSupported", "Multi valued attributes are not supported."));
    }
    if (!singleValue) {
        notices.push(t("ConfigurationRenderer:Warnings.SingleOptionBool.valuesMissing", "The true and false values are both missing or not active."));
    }
    else if (!singleValue.isActive) {
        notices.push(t("ConfigurationRenderer:Warnings.SingleOptionBool.valuesMissing", "The true and false values are both missing or not active."));
    }
    if (notices.length === 0) {
        return _jsx(Fragment, {});
    }
    return (_jsxs(Alert, { severity: "warning", children: [_jsxs(AlertTitle, { children: [t("ConfigurationRenderer:Warnings.SingleOptionBool.WarningTitle", "There are some issues with this control"), " ", attribute.id] }), _jsx("ul", { children: notices.map((notice, index) => (_jsx("li", { children: notice }, index))) })] }));
}
//# sourceMappingURL=SingleOptionBoolNotice.js.map